import { render, staticRenderFns } from "./verification_divider.vue.js?vue&type=template&id=b1e41c16!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./verification_divider.vue?vue&type=template&id=b1e41c16"
import script from "./verification_divider.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./verification_divider.vue?vue&type=script&lang=js"
export * from "./verification_divider.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./verification_divider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1e41c16')) {
      api.createRecord('b1e41c16', component.options)
    } else {
      api.reload('b1e41c16', component.options)
    }
    module.hot.accept("./verification_divider.vue.js?vue&type=template&id=b1e41c16!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./verification_divider.vue?vue&type=template&id=b1e41c16", function () {
      api.rerender('b1e41c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "authentication/sessions/components/verification_divider.vue"
export default component.exports